<template>
    <div>
        <section class="dashboard__general_bar">
          <p class="dashboard__general--title">Ofertas vistas</p>
          <div
            class="dashboard__general_bar--container"
            id="map_offers_view">
            <div class="dashboard__options">
              <app-date-picker
                v-if="map_offers_view"
                @filterQuery="updateChart('map_offers_view', true, false, $event)"></app-date-picker>
              <div
                class="dashboard__options--reload"
                @click="map_offers_view = false; updateChart('map_offers_view', true, true)">
                <img src="@/assets/img/icons/refresh-icon.svg" alt="">
              </div>
            </div>
            <apexchart
              style="overflow:visible;"
              width="100%"
              type="bar"
              :options="chartOptions['map_offers_view']"
              :series="series['map_offers_view']"></apexchart>
          </div>
        </section>
        <section class="dashboard__general_bar">
          <p class="dashboard__general--title">Ofertas con 'Me gusta'</p>
          <div
            class="dashboard__general_bar--container"
            id="offers_liked">
            <div class="dashboard__options">
              <app-date-picker
                v-if="offers_liked"
                @filterQuery="updateChart('offers_liked', true, false, $event)"></app-date-picker>
              <div
                class="dashboard__options--reload"
                @click="offers_liked = false; updateChart('offers_liked', true, true)">
                <img src="@/assets/img/icons/refresh-icon.svg" alt="">
              </div>
            </div>
            <apexchart
              style="overflow:visible;"
              width="100%"
              type="bar"
              :options="chartOptions['offers_liked']"
              :series="series['offers_liked']">
            </apexchart>
          </div>
        </section>
        <section class="dashboard__general_bar">
          <p class="dashboard__general--title">Ofertas canjeadas</p>
          <div
            class="dashboard__general_bar--container"
            id="offers_redeem">
            <div class="dashboard__options">
              <app-date-picker
                v-if="offers_redeem"
                @filterQuery="updateChart('offers_redeem', true, false, $event)"></app-date-picker>
              <div
                class="dashboard__options--reload"
                @click="offers_redeem = false; updateChart('offers_redeem', true, true)">
                <img src="@/assets/img/icons/refresh-icon.svg" alt="">
              </div>
            </div>
            <apexchart
              width="100%"
              type="bar"
              :options="chartOptions['offers_redeem']"
              :series="series['offers_redeem']"></apexchart>
          </div>
        </section>

        <section class="dashboard__general_bar">
          <p class="dashboard__general--title">Disponibilidad de ofertas</p>
          <div
            class="dashboard__general_bar--container"
            id="availability_offers">
            <div class="dashboard__options" style="justify-content: flex-end">
              <div
                class="dashboard__options--reload"
                @click="updateChart('availability_offers', true, true)">
                <img src="@/assets/img/icons/refresh-icon.svg" alt="">
              </div>
            </div>
            <apexchart
              style="overflow:visible;"
              type="bar"
              width="100%"
              :options="chartOptions['availability_offers']"
              :series="series['availability_offers']"></apexchart>
          </div>
        </section>
        <section class="dashboard__general_bar">
          <p class="dashboard__general--title">Me gusta vs Canjes</p>
          <div
            class="dashboard__general_bar--container"
            id="offers_like_vs_redeem">
            <div class="dashboard__options" style="justify-content: flex-end">
              <div
                class="dashboard__options--reload"
                @click="updateChart('availability_offers', true, true)">
                <img src="@/assets/img/icons/refresh-icon.svg" alt="">
              </div>
            </div>
            <apexchart
              style="overflow:visible;"
              type="bar"
              width="100%"
              :options="chartOptions['offers_like_vs_redeem']"
              :series="series['offers_like_vs_redeem']"></apexchart>
          </div>
        </section>
    </div>
</template>
<script>


import { mapGetters } from 'vuex'

export default {
    computed: {
      active_tab:{
        get: function () {
          return this.getDashboardActive()
        },
        set: function (newValue) {
          return this.updateDashboardActive(newValue)
        }
      }
    },
    data () {
      return {
        // active_tab:0,
        day_hour_actions: true,//f
        users_genre: true,//f
        users_ages: true,//f
        map_offers_view: true,//true
        offers_liked: true,//true
        offers_redeem: true,//true
        created_users: true,//f
        locations_liked: true,//f
        map_locations_view: true,//f
        locations_redemptions: true,//f
        map_rewards_view: true,//f
        rewards_liked: true,//f
        map_redeemed_rewards: true,//f
        map_win_rewards: true,//f
        //_________________________________________________________________suponiendo valores activos superiores
        all_queries: {},
        offers_titles: {},
        locations_titles:{},
        charts:["Usuarios","Ofertas","Locaciones","Rewards"],
        chartOptions: {
          created_users:{},
          offers_redeem: {},
          map_offers_view: {},
          map_rewards_view: {},
          map_locations_view: {},
          availability_offers: {},
          offers_liked: {},
          locations_liked: {},
          map_redeemed_rewards: {},
          map_win_rewards: {},
          day_hour_actions:{},
          users_genre:{},
          users_ages:{},
          rewards_liked: {},
          offers_like_vs_redeem: {},//true
          locations_redemptions: {}
        },
        series: {
          map_rewards_view: [],
          offers_redeem:[],
          created_users: [],
          map_offers_view: [],
          map_locations_view: [],
          availability_offers: [],
          offers_liked: [],
          rewards_liked: [],
          locations_liked: [],
          map_redeemed_rewards: [],
          map_win_rewards: [],
          day_hour_actions: [],
          users_genre: [0],
          users_ages: [0],
          offers_like_vs_redeem: [],
          locations_redemptions: []
        },
        totalUser: '',
        totalRedemptions:'',
        totalOffers:'',
        headers: [
          {
            text: 'Descripción',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          {
            text: 'Cantidad',
            value: 'quantity',
            align: 'center'
          }
        ],
        desserts: [
          {
            value: false,
            name: 'Total de usuarios registrados',
            quantity: ''
          },
          {
            value: false,
            name: 'Total de canjes',
            quantity: ''
          }
        ]
      }
    },
    watch:{
      series(){
      }
    },
    created(){
      this.active_tab='0';
      this.$http.get('charts/summary_clients',{
        params:{
          offset_time: new Date().getTimezoneOffset(),
          company: this.getCompany().id
        },
          headers: {
            "X-Device-ID" : this.getDeviceId(),
             "Authorization" : 'Bearer ' + this.getUserToken()
          }
      },).then(function(response){
        this.totalUser = response.body.data.total_users;
        this.totalRedemptions = response.body.data.total_redemptions;
        this.totalOffers = response.body.data.total_offers;
        this.all_queries = response.body.data.queries;
        var vm =this;
        vm.offers_titles = response.body.data.offers_titles;
        vm.locations_titles = response.body.data.locations_titles;
        vm.active_tab='0';
        for (var key in vm.all_queries) {
          vm.updateChart(key,false);
        }
        if(response.body.meta != undefined &&
           response.body.meta != null){
          if(response.body.meta.authentication_token != undefined &&
             response.body.meta.authentication_token != null){
            this.checkToken(response.body.meta.authentication_token)
          }
        }
        vm.updateDashboardActive(0)
        vm.users_genre = false
        vm.updateChart('users_genre', true, true)
        vm.users_ages = false
        vm.updateChart('users_ages', true, true)
      }, function(response){
        if(response.body.meta != undefined &&
           response.body.meta != null){
          if(response.body.meta.authentication_token != undefined &&
             response.body.meta.authentication_token != null){
            this.checkToken(response.body.meta.authentication_token)
          }
        }
      })
    },
    methods: {
      generateDayWiseTimeSeries: function (baseval, count) {
        var i = 0;
        var series = [];
        var vm = this;
        while (i < count) {
          var y = vm.all_queries['created_users'][new Date(baseval).toISOString().split('T')[0]];
          var x = baseval;
          if (y==undefined){
            y=0;
          }
          series.push([x, y]);
          baseval += 86400000;
          i++;
        }
        return series;
      },
      returnNameLabels(type, array, title = 'Diferente'){
        var vm=this;
        for(var i=0;i<array.length;i++){
          array[i]=vm[type+"_titles"][array[i]];
        }
        return array;
      },
      next () {
        const active = parseInt(this.active_tab)
        this.active_tab = (active < this.charts.length-1 ? active + 1 : 0)
      },
      generateData(hour,date_action,count,graph_info) {
        var vm = this;
        var i=0;
        var series = [];
        while (i < count) {
          var x = date_action.toISOString().split('T')[0];
          var y = 0;
          try {
            y = vm.all_queries[graph_info][x][hour];
            if(y==undefined){
              y = 0;
            }
          }
          catch(err) {
            y = 0;
          }
          series.push({
            x: x,
            y: y
          });
          date_action.setDate(date_action.getDate() + 1);
          i++;
        }
        return series;
      },
      generateDataBars(chart_name,hash_data){
        var new_hash={};
        if(chart_name=="availability_offers"){
          new_hash ={
            available:[],
            redeemed:[]
          }
          for ( var i in hash_data) {
            new_hash.available.push(hash_data[i]['available'])
            new_hash.redeemed.push(hash_data[i]['redeemed'])
          }
        }else if(chart_name=="like_vs_redeem"){
          new_hash ={
            like:[],
            redeemed:[]
          }
          var vm=this;
          for ( var i in hash_data) {
            var element=hash_data[i];
            if(vm.all_queries["offers_liked"][element]==undefined){
              new_hash.like.push(0);
            }else{
              new_hash.like.push(vm.all_queries["offers_liked"][element]);
            }
            if(vm.all_queries["offers_redeem"][element]==undefined){
              new_hash.redeemed.push(0);
            }else{
              new_hash.redeemed.push(vm.all_queries["offers_redeem"][element]);
            }
          }
        }
        return new_hash;
      },
      updateChart(graph_info, make_request, reload = false, dates) {
        var object = dates != undefined && dates != null ? dates : {date_from: new Date(new Date().setMonth(new Date().getMonth() - 2)), date_to: new Date()}
        var first_date_element = object.date_from
        var last_date_element = object.date_to
        var firstDate = null;
        var secondDate = null;
        if(first_date_element!=null && last_date_element!=null && !reload){
          if(first_date_element =="" || last_date_element ==""){
            if(make_request==true){
              // alert("Por favor ingrese la fecha inicial y final para hacer la nueva consulta");
              this.updateAlertMessage("Por favor ingrese la fecha inicial y final para hacer la nueva consulta");
              this.updateIsInAlert(true);
              make_request = false;
            }
            secondDate = new Date();
            secondDate.setHours(23,59,59);
            firstDate = new Date();
            firstDate.setHours(0,0,0,0);
            firstDate.setMonth(secondDate.getMonth() - 1);
          }else{
            secondDate = new Date(last_date_element);
            firstDate = new Date(first_date_element);
            secondDate.setHours(23,59,59);
            secondDate.setDate(secondDate.getDate() + 1);
            firstDate.setHours(0,0,0,0);
            firstDate.setDate(firstDate.getDate() + 1);
          }
        }
        if(reload){
          if(graph_info == 'availability_offers' ||
             graph_info == 'offers_like_vs_redeem'){
            var json_send={
              type: graph_info
            };
            this.$http.get('charts/query_without_dates',
            {
              params:{
                data: json_send,
                offset_time: new Date().getTimezoneOffset()
              },

              headers: {
                "X-Device-ID" : this.getDeviceId(),
                 "Authorization" : 'Bearer ' + this.getUserToken()
              }

            }).then(function(response){

              var vm = this
              this.all_queries[graph_info]=response.body.data.queries[graph_info];
              this.all_queries['offers_redeem']=response.body.data.queries['offers_redeem']
              this.all_queries['offers_liked']=response.body.data.queries['offers_liked']
              this.updateChart(graph_info, false);
              // var temp_labels = Object.keys(vm.all_queries["offers_redeem"]);
              // temp_labels = temp_labels.concat(Object.keys(vm.all_queries["offers_liked"]));
              // var labels_vs = temp_labels.filter(function(elem, index, self) {
              //     return index === self.indexOf(elem);
              // });
              // var data_bars_vs=vm.generateDataBars("like_vs_redeem",labels_vs);
              // labels_vs=vm.returnNameLabels("offers",labels_vs);
              // vm.series["offers_like_vs_redeem"]=[{
              //     name: 'Me Gusta',
              //     data: data_bars_vs.like
              // },{
              //     name: 'Canjes',
              //     data: data_bars_vs.redeemed
              // }];
              if(response.body.meta != undefined &&
                 response.body.meta != null){
                if(response.body.meta.authentication_token != undefined &&
                   response.body.meta.authentication_token != null){
                  this.checkToken(response.body.meta.authentication_token)
                }
              }
            }, function(response){
              if(response.body.meta != undefined && response.body.meta != null){
                if(response.body.meta.authentication_token != undefined &&
                   response.body.meta.authentication_token != null){
                  this.checkToken(response.body.meta.authentication_token)
                }
              }
            })
          }else{
            var json_send={
              query_name: graph_info,
              init_date: '',
              offset_time: new Date().getTimezoneOffset(),
              finish_date: ''
            };
            this.$http.post('charts/query_with_dates',{
              data: this.encrypt(json_send).toString()
            },{
              headers: {
                "X-Device-ID" : this.getDeviceId(),
                 "Authorization" : 'Bearer ' + this.getUserToken()
              }}).then(function(response){
              this.all_queries[graph_info]=response.body.data[graph_info];
              this.updateChart(graph_info, false);
              this.day_hour_actions = true
              this.users_genre = true
              this.users_ages = true
              this.map_offers_view = true
              this.offers_liked = true
              this.offers_redeem = true
              this.created_users = true
              this.locations_liked = true
              this.map_locations_view = true
              this.locations_redemptions = true
              this.map_rewards_view = true
              this.rewards_liked = true
              this.map_redeemed_rewards = true
              this.map_win_rewards = true
              if(response.body.meta != undefined &&
                 response.body.meta != null){
                if(response.body.meta.authentication_token != undefined &&
                   response.body.meta.authentication_token != null){
                  this.checkToken(response.body.meta.authentication_token)
                }
              }
            }, function(response){
              if(response.body.meta != undefined && response.body.meta != null){
                if(response.body.meta.authentication_token != undefined &&
                   response.body.meta.authentication_token != null){
                  this.checkToken(response.body.meta.authentication_token)
                }
              }
            })
          }
        }
        if(make_request && secondDate!=null && firstDate!=null && !reload){
          var json_send={
            query_name: graph_info,
            init_date: this.$moment(firstDate).format("YYYY-MM-DD"),
            offset_time: new Date().getTimezoneOffset(),
            finish_date: this.$moment(secondDate).format("YYYY-MM-DD")
          };
          this.$http.post('charts/query_with_dates',{
            data: this.encrypt(json_send).toString()
          },{
            headers: {
              "X-Device-ID" : this.getDeviceId(),
               "Authorization" : 'Bearer ' + this.getUserToken()
            }}).then(function(response){
            this.all_queries[graph_info]=response.body.data[graph_info];
            this.updateChart(graph_info, false);
            if(response.body.meta != undefined &&
               response.body.meta != null){
              if(response.body.meta.authentication_token != undefined &&
                 response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
            if(graph_info == 'day_hour_actions'){
              var vm = this
              var oneDay = 24*60*60*1000;
              get_first_time = firstDate.getTime();
              get_second_time = secondDate.getTime();
              var diffDays = Math.round(Math.abs((get_first_time - get_second_time)/(oneDay)));
              var series_array=[];
              var count_temp=0;
              for(var i = 23;i>=0;i--){
                var copiedDate = new Date(firstDate.getTime()-oneDay);
                var hour=i+':00';
                var series={
                  name: hour,
                  data: vm.generateData(hour,copiedDate,diffDays,graph_info)
                };
                count_temp++;
                series_array.push(series);
              }
              // vm.updateSeries(series_array, true)
              vm.series[graph_info] = series_array;
            }else if(graph_info == 'created_users'){
              var vm = this
              var oneDay = 24*60*60*1000; // hours*minutes*seconds*milliseconds

              var get_first_time = firstDate.getTime();
              var get_second_time = secondDate.getTime();


              var diffDays = Math.round(Math.abs((get_first_time - get_second_time)/(oneDay)));


              vm.series[graph_info]=[{
                data: this.generateDayWiseTimeSeries(get_first_time - oneDay, diffDays)
              }];

            }
          }, function(response){
            if(response.body.meta != undefined &&
               response.body.meta != null){
              if(response.body.meta.authentication_token != undefined &&
                 response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
          })
          // Hacer la petición de actualización
        }else{
          var vm = this;
          // Make sure to update the whole options config and not just a single property to allow the Vue watch catch the change.
          switch (graph_info) {
            case "day_hour_actions":
              vm.chartOptions[graph_info]={
                chart: {
                  height: 600,
                  type: 'heatmap',
                  toolbar:{
                    show: false
                  }
                },
                xaxis: {
                  labels:{
                    rotate:-90
                  }
                },
                dataLabels: {
                    enabled: false
                },
                colors: ["#8966FF"]
              }
              var oneDay = 24*60*60*1000;
              get_first_time = firstDate.getTime();
              get_second_time = secondDate.getTime();
              var diffDays = Math.round(Math.abs((get_first_time - get_second_time)/(oneDay)));
              var series_array=[];
              var count_temp=0;
              for(var i = 23;i>=0;i--){
                var copiedDate = new Date(firstDate.getTime());
                var hour=i+':00';
                var series={
                  name: hour,
                  data: vm.generateData(hour,copiedDate,diffDays,graph_info)
                };
                count_temp++;
                series_array.push(series);
              }
              // vm.updateSeries(series_array, true)
              vm.series[graph_info] = series_array;
              break;
            case "created_users":
              var oneDay = 24*60*60*1000; // hours*minutes*seconds*milliseconds

              var get_first_time = firstDate.getTime();
              var get_second_time = secondDate.getTime();

              var diffDays = Math.round(Math.abs((get_first_time - get_second_time)/(oneDay)));
              vm.series[graph_info]=[{
                data: this.generateDayWiseTimeSeries(get_first_time, diffDays)
              }];

              vm.chartOptions['created_users']={
                colors: ["#8966FF"],
                chart:{
                  height: 350,
                  zoom: {
                    enabled: true
                  },
                },
                xaxis: {
                  type: 'datetime'
                }
              };
              break;
            case "availability_offers":
              var labels = Object.keys(vm.all_queries[graph_info]);
              labels=vm.returnNameLabels("offers",labels);
              var data_bars=vm.generateDataBars("availability_offers",vm.all_queries[graph_info]);
              vm.series[graph_info]=[{
                  name: 'Canjeadas',
                  data: data_bars.redeemed
              },{
                  name: 'Disponibles',
                  data: data_bars.available
              }];
              vm.chartOptions[graph_info]={
                chart: {
                  stacked: true,
                  toolbar: {
                    show: false
                  },
                  zoom: {
                    enabled: true
                  },
                  height: labels.length > 0 ? (labels.length * 50) + 100 : 200
                },
                colors: ["#8966FF", "#5DEAA9"],
                xaxis: {
                    categories: labels,
                },

              }
              case "offers_like_vs_redeem":
              var temp_labels = Object.keys(vm.all_queries["offers_redeem"]);
              temp_labels = temp_labels.concat(Object.keys(vm.all_queries["offers_liked"]));
              var labels_vs = temp_labels.filter(function(elem, index, self) {
                  return index === self.indexOf(elem);
              });
              var data_bars_vs=vm.generateDataBars("like_vs_redeem",labels_vs);
              labels_vs=vm.returnNameLabels("offers",labels_vs);
              vm.series["offers_like_vs_redeem"]=[{
                  name: 'Me Gusta',
                  data: data_bars_vs.like
              },{
                  name: 'Canjes',
                  data: data_bars_vs.redeemed
              }];
              vm.chartOptions["offers_like_vs_redeem"]={
                chart: {
                  stacked: true,
                  toolbar: {
                    show: false
                  },
                  zoom: {
                    enabled: true
                  },
                  height: labels.length > 0 ? (labels.length * 50) + 100 : 200
                },
                 colors: ["#FF6D89", "#5DEAA9"],
                xaxis: {
                    categories: labels_vs,
                },

              }
              // vm.chartOptions["offers_like_vs_redeem"]={
              //   plotOptions: {
              //     bar: {
              //       horizontal: true,
              //     }
              //   },
              //   chart: {
              //     stacked: true,
              //     toolbar: {
              //       show: false
              //     },
              //     zoom: {
              //       enabled: true
              //     },
              //     height: labels_vs.length > 0 ? (labels_vs.length * 50) + 120 : 200
              //   },
              //   responsive: [{
              //     breakpoint: 480,
              //     options: {
              //       legend: {
              //         position: 'bottom',
              //         offsetX: -10,
              //         offsetY: 0
              //       }
              //     }
              //   }],
              //   colors: ["#FF6D89", "#5DEAA9"],
              //   xaxis: {
              //       categories: labels_vs,
              //   },
              //   fill: {
              //       opacity: 1,
              //       colors: ["#FF6D89", "#5DEAA9"]
              //   },
              //   legend: {
              //       position: 'top',
              //       offsetX: 0,
              //       offsetY: 0
              //   }
              // }
              break;
            case "offers_redeem":
            case "map_offers_view":
            case "map_rewards_view":
            case "map_locations_view":
            case "offers_liked":
            case "rewards_liked":
            case "locations_liked":
            case "locations_redemptions":
            case "map_redeemed_rewards":
            case "map_win_rewards":
              // Get an array of the keys:
              var obj = vm.all_queries[graph_info];
              var keys = Object.keys(obj);
              // keys.sort(function(a, b) { return Number(obj[a]) - Number(obj[b]) });
              // var labels = keys.reverse();
              var labels = keys
              if(graph_info=="offers_redeem" ||
                  graph_info=="map_offers_view" ||
                  graph_info=="offers_liked" ||
                  graph_info=="rewards_liked" ||
                  graph_info=="map_rewards_view" ||
                  graph_info=="map_redeemed_rewards" ||
                  graph_info=="map_win_rewards"){
                // labels=vm.returnNameLabels("offers",labels, graph_info)
              }else if(graph_info=="map_locations_view" ||
                  graph_info=="locations_liked" ||
                  graph_info=="locations_redemptions"){
                labels=vm.returnNameLabels("locations",labels)
              }
              vm.series[graph_info]=[{name:"Cantidad",data: Object.values(vm.all_queries[graph_info])}];
              vm.series[graph_info][0].data.sort(function(a, b){
                return a < b;
              });
              let variable_colors = []
              if(graph_info == "map_offers_view" ||
                 graph_info == "locations_liked" ||
                 graph_info == "map_rewards_view"){
                variable_colors.push("#8966FF");
              }else
              if(graph_info == "offers_liked" ||
                 graph_info == "map_locations_view" ||
                 graph_info == "rewards_liked"){
                variable_colors.push("#FF6D89");
              }else
              if(graph_info == "offers_redeem" ||
                 graph_info == "locations_redemptions" ||
                 graph_info == "map_redeemed_rewards"){
                variable_colors.push("#5DEAA9");
              }else
              if(graph_info == "map_win_rewards"){
                variable_colors.push("#F7C554")
              }else{
                variable_colors.push("#5DEAA9")
              }
              vm.chartOptions[graph_info]={
                type:"bar",
                plotOptions: {
                  bar: {
                    horizontal: true,
                  }
                },
                chart: {
                  toolbar:{
                    show: false
                  },
                  height: labels.length > 0 ? (labels.length * 50) + 90 : 200
                },
                fill:{
                  colors:variable_colors
                },
                dataLabels: {
                  enabled: false,
                  offsetY: -20,
                  style: {
                    fontSize: '12px',
                    colors: ["#304758"]
                  }
                },
                stroke: {
                  width: 1,
                  colors: ['#fff']
                },
                xaxis: {
                  categories: labels,
                },
                yaxis: {
                  labels: {
                    show: true
                  }
                },
                tooltip: {
                  x: {
                    show: true
                  }
                }
              };
              break;
            case 'users_genre':
            case 'users_ages' :
              vm.series[graph_info]=Object.values(vm.all_queries[graph_info]);
              vm.chartOptions[graph_info]={
                colors: ["#F7C554","#8966FF","#FF6D89","#49ADFB","#5DEAA9","#4DCEED"],
                labels: Object.keys(vm.all_queries[graph_info]),
                dataLabels: {
                  offsetY: 5,
                  offsetX: 5,
                  textAnchor: 'middle',
                  style: {
                    fontSize: '13px',
                    colors: ["#FFF"],
                    fontFamily: 'Poppins',
                  }
                },
                legend: {
                  position: 'right',
                  offsetY: 50,
                  horizontalAlign: 'center',
                  verticalAlign: 'middle',
                  markers: {
                    width: 12,
                    height: 12,
                    radius: 4
                  },
                  itemMargin: {
                    horizontal: 5,
                  },
                },
                width: 300,
                responsive: [{
                  breakpoint: 480,
                  options: {
                    chart: {
                      width: 200
                    },
                    legend: {
                      position: 'center'
                    }
                  }
                }]
              };
              break;
          }
        }
      }
    }
  }
</script>

<style lang="scss">
  .charts_container{
    .numbers{
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: space-between;
      .number_container{
        background: #fff;
        -webkit-box-shadow: 5px 5px 6px 0px rgba(53, 53, 69, 0.15);
        -moz-box-shadow: 5px 5px 6px 0px rgba(53, 53, 69, 0.15);
        box-shadow: 5px 5px 6px 0px rgba(53, 53, 69, 0.15);
        display: flex;
        padding: 20px 0px;
        justify-content: center;
        width: calc(25% - 20px);
        border-radius: 2px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/summary/Offers_index.vue